var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sip_ui_border"},[_c('div',{staticClass:"sip_controls sip_ui_body"},[_c('ControlsSpeedometr',{attrs:{"speed":_vm.speed}}),_c('ControlsUpDown',{on:{"clicked":_vm.onUpDown}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }